export default function LanguageSelector() {
    const wrapper = document.querySelector('[data-language-selector]');

    const button = wrapper?.querySelector<HTMLElement>('[data-language-selector-button]');

    const flagContainer = wrapper?.querySelector<HTMLElement>(
        '[data-language-flag-list]'
    );

    const flags = flagContainer?.querySelectorAll<HTMLElement>('[data-menu-link-flag]');
    const firstFlag = flags && flags.length > 0 ? flags[0] : null;

    function handleOpenDropdown() {
        wrapper?.setAttribute('aria-expanded', 'true');
        document.addEventListener('focus', closeDropdownOnOutsideFocus, true);
    }

    function handleCloseDropdown() {
        wrapper?.setAttribute('aria-expanded', 'false');
        window.removeEventListener('keydown', handleWindowKeydown);
        document.removeEventListener('focus', closeDropdownOnOutsideFocus, true);
    }

    function handleButtonKeydown(event: KeyboardEvent) {
        switch (event.code) {
            case 'Space':
            case 'Enter':
                handleOpenDropdown();
                handleFocus(firstFlag as HTMLElement);
                break;
            default:
                break;
        }
    }

    function handleWindowKeydown(event: KeyboardEvent) {
        switch (event.code) {
            case 'Escape':
                handleCloseDropdown();
                handleFocus(button as HTMLElement);
                break;
            default:
                break;
        }
    }

    function handleFocus(element: HTMLElement) {
        element && element.focus();
    }

    button?.addEventListener('focus', () => {
        button?.addEventListener('keydown', event => {
            handleButtonKeydown(event);
        });
        window.addEventListener('keydown', event => {
            handleWindowKeydown(event);
        });
    });

    function closeDropdownOnOutsideFocus() {
        if (!flagContainer?.contains(document.activeElement)) {
            handleCloseDropdown();

            handleFocus(button as HTMLElement);
        }
    }
}
